import { render, staticRenderFns } from "./add-to-cart.vue?vue&type=template&id=725c58f2&"
import script from "./add-to-cart.vue?vue&type=script&lang=js&"
export * from "./add-to-cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports